import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarGraph = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 11 11",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M3.5 2.333H2.333v5.834H3.5V2.333ZM5.833 2.333H4.667V5.25h1.166V2.333ZM8.167 2.333H7V7h1.167V2.333Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M9.333 0H1.167A1.17 1.17 0 0 0 0 1.167v8.166A1.17 1.17 0 0 0 1.167 10.5h8.166A1.17 1.17 0 0 0 10.5 9.333V1.167A1.17 1.17 0 0 0 9.333 0Zm0 9.333H1.167V1.167h8.166v8.166Z"
		})
	]
});
const ForwardRef = forwardRef(SvgBarGraph);
export { ForwardRef as ReactComponent };
